import styled from 'styled-components';

import { translate } from '@wecasa/i18n';

import Alert from '@wecasa/web-ui/src/components/alert/alert';

const t = translate('basket.cleaning.services');

const StyledAlert = styled(Alert)`
  margin: 10px 0;
`;

type TaxCreditChoiceAlertProps = {
  isInstantTaxCreditSelected: boolean;
  isWecasaCarePairingSuccessful: boolean;
};

export const TaxCreditChoiceAlert = ({
  isInstantTaxCreditSelected,
  isWecasaCarePairingSuccessful,
}: TaxCreditChoiceAlertProps) => {
  if (isWecasaCarePairingSuccessful) {
    return <StyledAlert content={t('.tax.itc_alert.paired_successfully')} type='success' />;
  }
  if (isInstantTaxCreditSelected) {
    return <StyledAlert content={t('.tax.itc_alert.itc_selected')} type='success' />;
  }
  return <StyledAlert content={t('.tax.itc_alert.itc_not_selected')} type='info' />;
};
